import styled, { css } from 'styled-components';
import { sectionTokens } from '../../tokens/components/Section/tokens';

/* @internal */
export const StyledSection = styled.section`
  margin-bottom: ${sectionTokens.CoreSpacingWrapperMarginBottom};

  &:last-child {
    margin-bottom: 0;
  }

  ${({ theme }) =>
    theme.trim &&
    css`
      margin-bottom: 0;
    `}
`;

export const SectionHeader = styled.div`
  align-items: baseline;
  display: flex;
  justify-content: space-between;
`;

export const SectionBody = styled.div`
  margin-bottom: ${sectionTokens.CoreSpacingBodyMarginBottom};
  margin-top: ${sectionTokens.CoreSpacingBodyMarginTop};
`;

export const SectionAction = styled.div`
  ${({ theme }) =>
    !theme.hasActionsOnly &&
    css`
      margin-left: 56px;
    `}
`;
